/**
 * Input Schema of FormatoArquivoRelatorio
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {FormatoArquivoRelatorio} from '@/model/resource/FormatoArquivoRelatorio'

/* TODO: review generated schema */
export class InputFormatoArquivoRelatorioSchema extends Schema {
  readonly name = 'InputFormatoArquivoRelatorio'

  readonly fieldSet: FieldSet<FormatoArquivoRelatorio> = {
    descricao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 10,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
